import { Placeholder } from "@/components/Placeholder";

export function Sage() {
  return <Placeholder title="Sage" week="Week 4" />;
}
